import { stripeUrl } from './StripeStore';

export const updateStripeUrl = (value) => stripeUrl.update(oldValue => value);
